export default "__VITE_ASSET__B122aM_n__"